import { useContext } from 'react';
import ConfirmActionContext, { ConfirmActionContextType } from './ConfirmActionContext';

export default (): ConfirmActionContextType => useContext<ConfirmActionContextType>(ConfirmActionContext);
